export const currency = (value: number, roundingCount = 0): string => {
    const parsedValue = Math.round(value * (Math.pow(10, roundingCount))) / (Math.pow(10, roundingCount));

    let [decimal, fraction] = parsedValue.toString().split('.');

    if (decimal.length > 3) {
        decimal = decimal.split('').reverse().map((item, index) => !index || index % 3 ? item : `${item} `).reverse().join('');
    }

    if (roundingCount) {
        if (!fraction) {
            fraction = '';
        }

        if (fraction.length >= roundingCount) {
            fraction = fraction.substr(0, roundingCount);
        } else {
            fraction += '0'.repeat(roundingCount - fraction.length);
        }
    }

    if (!fraction || !roundingCount) {
        return decimal;
    }

    return `${decimal},${fraction}`;
};

export const numeralForm = (count: number, singular: string, plural: string, pluralGenitive: string): string => {
    if (count === 1) {
        return singular;
    }

    if (count % 100 > 10 && count % 100 < 20) {
        return pluralGenitive;
    }

    if (count % 10 > 1 && count % 10 < 5) {
        return plural;
    }

    return pluralGenitive;
};
